module.exports = __webpack_public_path__ + "static/media/main idea.9fa25e05.mp3";